import React from 'react';
import OutlinedLoading from 'acud-icon/lib/icons/OutlinedLoading';
const LoadingIcon = () => (<OutlinedLoading animation="spin"/>);
export default LoadingIcon;
